/**
 * Fullscreen viewer for the ctr-main-product gallery. Reuses CtrBuyBoxLightbox
 * from ctr-buy-box.js and works with both gallery snippets.
 */
(() => {
  // Mirrors CTR_TALL_RATIO in ctr-buy-box.js.
  const TALL_RATIO = 0.9;
  const SLIDES = '[id^="Slider-Gallery-"] li[data-media-id]';
  const DRAG_PX = 8;

  // ctr-buy-box.js declares top-level classes, so loading it twice throws.
  const loadViewer = (root) => {
    const css = root.dataset.ctrZoomCss;
    const js = root.dataset.ctrZoomJs;
    if (css && !document.querySelector('link[href*="ctr-buy-box.css"]')) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = css;
      document.head.appendChild(link);
    }
    if (js && !document.querySelector('script[src*="ctr-buy-box.js"]')) {
      const script = document.createElement('script');
      script.src = js;
      document.head.appendChild(script);
    }
  };

  const imageSlides = (root) =>
    Array.from(root.querySelectorAll(SLIDES)).filter(
      (slide) => slide.querySelector('.product__media img') && !slide.querySelector('deferred-media, product-model')
    );

  const toViewerImage = (slide) => {
    const img = slide.querySelector('.product__media img');
    const w = Number(img.getAttribute('width'));
    const h = Number(img.getAttribute('height'));
    return { src: img.src, alt: img.alt, tall: w > 0 && h > 0 && w / h < TALL_RATIO };
  };

  const addButtons = (root) => {
    imageSlides(root).forEach((slide, i) => {
      // Kept outside <modal-opener>, which binds the first <button> inside it to #ProductModal.
      const host = slide.querySelector('.product-media-container') || slide.querySelector('.product__media');
      if (!host || host.querySelector(':scope > .ctr-zoom-btn')) return;
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ctr-zoom-btn';
      btn.setAttribute('aria-label', 'Open image ' + (i + 1) + ' in fullscreen');
      host.appendChild(btn);
    });
  };

  const bind = (root) => {
    if (root.ctrZoomBound) return;
    root.ctrZoomBound = true;

    let startX = 0;
    let startY = 0;
    root.addEventListener(
      'pointerdown',
      (event) => {
        startX = event.clientX;
        startY = event.clientY;
      },
      { passive: true }
    );

    root.addEventListener('click', (event) => {
      const slide = event.target.closest(SLIDES);
      const viaButton = !!event.target.closest('.ctr-zoom-btn');
      if (!slide || !(viaButton || event.target.closest('.product__media'))) return;
      if (!viaButton && (Math.abs(event.clientX - startX) > DRAG_PX || Math.abs(event.clientY - startY) > DRAG_PX)) return;
      if (typeof CtrBuyBoxLightbox === 'undefined') return;
      const slides = imageSlides(root);
      const index = slides.indexOf(slide);
      if (index === -1) return;
      event.preventDefault();
      CtrBuyBoxLightbox.get().open(slides.map(toViewerImage), index);
    });

    addButtons(root);
    // product-info.js can re-render the slides on variant change.
    new MutationObserver(() => addButtons(root)).observe(root, { childList: true, subtree: true });
    loadViewer(root);
  };

  const init = (scope) => scope.querySelectorAll('[data-ctr-zoom]').forEach(bind);

  init(document);

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  }
})();
